import { Box, Flex, Text } from "@chakra-ui/react";
import { useTreasury } from "@/hooks/useTreasury";
import { DynamicTable, ColumnDefinition } from "@/components/DynamicTable";

interface LedgerItem {
  data: string;
  operacao: string;
  valor: string;
  positivo?: boolean;
}

export default function RendimentosTable() {
  const { ledger, isLoadingLedger } = useTreasury();

  const columns: ColumnDefinition<LedgerItem>[] = [
    {
      key: "data",
      title: "Data",
      dataIndex: "data",
      render: (data: string) => (
        <Text>{data}</Text>
      ),
    },
    {
      key: "operacao",
      title: "Operação",
      dataIndex: "operacao",
      render: (operacao: string) => (
        <Text>{operacao}</Text>
      ),
    },
    {
      key: "valor",
      title: "Valor",
      dataIndex: "valor",
      render: (valor: string, record: LedgerItem) => (
        <Text
          fontWeight={record.positivo ? "semibold" : "normal"}
          color={record.positivo ? "green.500" : "gray.800"}
          textAlign="right"
        >
          {valor}
        </Text>
      ),
    },
  ];

  return (
    <Box
      bgColor="white"
      borderWidth="1px"
      borderRadius="6px"
      borderColor="gray.50"
      p={5}
      minH="300px"
    >
      <Flex justify="space-between" mb={5}>
        <Text fontSize="lg" fontWeight="semibold">
          Extrato
        </Text>
      </Flex>

      <DynamicTable
        data={ledger || []}
        columns={columns}
        loading={isLoadingLedger}
        rowKey={(record) => `${record.data}-${record.operacao}-${record.valor}`}
        locale={{ emptyText: "Sem lançamentos" }}
      />
    </Box>
  );
}
